<template>
    <MainContent title="Crear plantilla">
        <template v-slot:header>
            <h3 class="card-title mb-3">Crear plantilla</h3>
        </template>
        <template v-slot:content>
            <Stepper 
                ref="stepper"
                :steps="steps" 
            >
                <template #pasoDatos="{ changeStep }">
                    <PasoUnoPlantilla :plantilla.sync="plantilla" :loading="loading" @finalizarPasoUno="changeStep" />
                </template>
                <template #pasoDesign>
                    <PasoDosPlantilla :plantilla.sync="plantilla" :loading="loading" @finalizarPasoDos="crearPlantilla" :error.sync="error" />
                </template>
            </Stepper>
        </template>        
    </MainContent>    
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from '@/components/backend/components/MainContent';
    import Stepper from '@/components/frontend/events/compra/components/Stepper.vue';
    import PasoUnoPlantilla from '@/views/backend/campana-emails/plantilla-boletines/PasoUnoPlantilla';
    import PasoDosPlantilla from '@/views/backend/campana-emails/plantilla-boletines/PasoDosPlantilla';

    export default {
        data() {
            return {
                plantilla: {},
                loading: false,
                steps: [
                    { label: "Rellena los datos", slot: "pasoDatos" },
                    { label: "Diseño", slot: "pasoDesign" }
                ],
                error: false,
            }
        },
        methods: {
            async crearPlantilla() {
                this.loading = true;

                try {
                    const payload = {
                        nombre: this.plantilla.nombre,
                        description: this.plantilla.descripcion,
                        html: this.plantilla.contenido,
                    };

                    const response = await apiService.createPlantilla(payload);
                    this.$toast.success(response.message);
                    this.$router.push('/admin/emails/plantillas');
                } catch (error) {
                    this.error = true;
                    console.error('Error al crear plantilla:', error);
                    this.$toast.error('Error al crear plantilla');
                } finally {
                    this.loading = false;
                }
            }
        },
        components: {
            Stepper, MainContent, PasoUnoPlantilla, PasoDosPlantilla
        }
    }
</script>